import { useDispatch } from "react-redux";
import { beginLoading, endLoading } from "../features/auth/uiControlSlice";

const useLoading = () => {
  const dispatch = useDispatch();

  const startLoading = () => {
    dispatch(beginLoading());
  };

  const stopLoading = () => {
    dispatch(endLoading());
  };

  return { startLoading, stopLoading };
};

export default useLoading;
